import React, { useState } from 'react';
import { UserPlus } from 'lucide-react';

function AddUserModal({ onClose, onAdd }) {
  const [form, setForm] = useState({ name: '', email: '', phone: '' });

  const handleSubmit = () => {
    if (!form.name || !form.email || !form.phone) return alert('Please fill all fields.');
    const newUser = {
      id: `#VK${String(Math.floor(Math.random() * 900) + 100)}`,
      name: form.name,
      email: form.email,
      phone: form.phone,
      races: 0,
      status: 'Active',
      joined: new Date().toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' }),
    };
    onAdd(newUser);
    onClose();
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      zIndex: 9999, padding: 16,
    }}>
      <div className="card animate-in" style={{ width: '100%', maxWidth: 480, maxHeight: '90vh', overflowY: 'auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
          <h2 className="font-heading" style={{ fontSize: 20 }}>Add New User</h2>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: 'var(--text-muted)', cursor: 'pointer', fontSize: 20 }}>✕</button>
        </div>
        <div className="form-group">
          <label className="form-label">Full Name</label>
          <input className="form-control" placeholder="Enter full name"
            value={form.name} onChange={e => setForm(p => ({ ...p, name: e.target.value }))} />
        </div>
        <div className="form-group">
          <label className="form-label">Email</label>
          <input className="form-control" type="email" placeholder="user@email.com"
            value={form.email} onChange={e => setForm(p => ({ ...p, email: e.target.value }))} />
        </div>
        <div className="form-group">
          <label className="form-label">Phone</label>
          <input className="form-control" placeholder="+1 702-555-0000"
            value={form.phone} onChange={e => setForm(p => ({ ...p, phone: e.target.value }))} />
        </div>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end', marginTop: 8 }}>
          <button className="btn-secondary" onClick={onClose}>Cancel</button>
          <button className="btn-primary" onClick={handleSubmit}>
            <UserPlus size={14} /> Add User
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddUserModal;